'use client';

import React, { useState } from 'react';
import Filters from '../others/Filters';
import CatalogueTable from '../others/CatalogueTable';
import { AdminCatalogueView, SelectedSample } from '../Catalogue';

export type visibilityType = 'all' | 'public' | 'restricted' | 'hidden';

export interface CatalogueFilters {
  search: string;
  searchAuthor: string;
  visibility: visibilityType;
  group: string;
}

export type SortDirection = 'none' | 'asc' | 'desc';

export interface SortState {
  titleSort: SortDirection;
  authorSort: SortDirection;
}

interface ICatalogueTableView {
  setView: React.Dispatch<React.SetStateAction<AdminCatalogueView>>;
  selectedSamples: SelectedSample[];
  setSelectedSamples: React.Dispatch<React.SetStateAction<SelectedSample[]>>;
  onCsvReview: (data: { matched: SelectedSample[]; unmatched: string[] }) => void;
}

const CatalogueTableView = ({ setView, selectedSamples, setSelectedSamples, onCsvReview }: ICatalogueTableView) => {
  const [filters, setFilters] = useState<CatalogueFilters>({
    search: '',
    searchAuthor: '',
    visibility: 'all',
    group: 'all',
  });

  // Sorting state - default: no sorting. Only one sort active at a time.
  const [sort, setSort] = useState<SortState>({
    titleSort: 'none',
    authorSort: 'none',
  });

  const handleSortChange = (column: 'title' | 'author') => {
    setSort((prev) => {
      const currentValue = column === 'title' ? prev.titleSort : prev.authorSort;
      const nextValue: SortDirection = currentValue === 'none' ? 'asc' : currentValue === 'asc' ? 'desc' : 'none';

      // Reset the other sort to 'none' when one is activated
      return {
        titleSort: column === 'title' ? nextValue : 'none',
        authorSort: column === 'author' ? nextValue : 'none',
      };
    });
  };
  const [page, setPage] = useState(1);

  const handleFilterChange = (key: keyof CatalogueFilters, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPage(1); // Reset to first page when filters change
  };

  return (
    <div data-testid="catalogue-table-view" className="flex flex-col h-full">
      <Filters filters={filters} onFilterChange={handleFilterChange} />
      <div className="flex-1 min-h-0">
        <CatalogueTable
          filters={filters}
          page={page}
          onPageChange={setPage}
          selectedSamples={selectedSamples}
          onSelectionChange={setSelectedSamples}
          setView={setView}
          sort={sort}
          onSortChange={handleSortChange}
          onCsvReview={onCsvReview}
        />
      </div>
    </div>
  );
};

export default CatalogueTableView;
